"use client";

import { useTranslations } from "next-intl";

const NAMESPACE = "new-fdm-fused-deposition-modeling";

export default function WhatIsFdm() {
	const t = useTranslations(NAMESPACE);

	return (
		<section className="bg-white py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<div className="grid items-center gap-6 md:gap-10 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.6fr)] lg:gap-16">
					<h2 className="text-2xl font-bold leading-tight text-black sm:text-[30px] md:text-4xl">
						{t("whatIsFdmTitle1")}
						<br />
						{t("whatIsFdmTitle2")}
					</h2>
					<div className="space-y-4 text-sm leading-relaxed text-black md:text-base">
						<p>{t("whatIsFdmDesc1")}</p>
						<p>{t("whatIsFdmDesc2")}</p>
					</div>
				</div>
			</div>
		</section>
	);
}
